/* DeleteAction.js */

"use strict";

const PLATFORM_NAME_MAX_LENGTH = 60;
const WARNING_LINKED_DEVICES =
    "Sorry! IoT Platform linked to one or more IoT Devices cannot be deleted.";

class DeleteAction {
    constructor(logger, gameEditor, modalUserFeedback, odmOsPlatformEntity) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._odmOsPlatformEntity = odmOsPlatformEntity;
        this.doTheThang = this.doTheThang.bind(this);
    }

    run() {
        const platform = this._gameEditor.getPlatform();
        if (!platform) {
            return this._modalUserFeedback.displayError({
                error: {
                    title: "Delete",
                    errorTitle: "Delete IoT Platform",
                    errorMsg: "No platform is currently open.",
                    errorCode: "",
                },
            });
        }

        this._platformName = platform.name || "";
        const shortPlatformName =
            this._platformName.length > PLATFORM_NAME_MAX_LENGTH
                ? this._platformName.substring(0, PLATFORM_NAME_MAX_LENGTH - 1) + "…"
                : this._platformName;
        const deviceCount = platform.deviceCount || 0;

        // Platform linked to devices cannot be deleted
        if (deviceCount > 0) {
            return this._modalUserFeedback.displayError({
                error: {
                    title: "Delete",
                    errorTitle: "Delete IoT Platform",
                    errorMsg: WARNING_LINKED_DEVICES,
                    errorCode: "",
                },
            });
        }

        const message = `Are you sure you want to delete this IoT Platform?\n\n${shortPlatformName}`;

        return this._gameEditor
            .runQuickConfirmationActionWorkflow(
                {
                    message: message,
                    title: "Delete",
                    confirmDetails: {
                        text: "Confirm",
                        type: "destructive",
                    },
                    rejectDetails: {
                        text: "Cancel",
                        type: "text",
                    },
                },
                this.doTheThang
            )
            .finally(() => {
                if (this._gameEditor.currentEntityRemoved) {
                    this._gameEditor.currentEntityRemoved = false;
                    this._gameEditor.currentEntityDeleteInProgress = false;
                    this._gameEditor.closeEditor(this._gameEditor.editorTabStateId, true);
                }
            });
    }

    doTheThang() {
        this._gameEditor.currentEntityDeleteInProgress = true;
        const platform = this._gameEditor.getPlatform();
        const showProgFunc = () => {
            this._modalUserFeedback.showLoadingProgress(`Deleting ${this._platformName}`);
        };

        return platform
            .runDeleteOdmOsPlatformWork({}, showProgFunc)
            .then((workResults) => {
                this._odmOsPlatformEntity.throwWorkErrors(workResults);
                return Promise.resolve();
            })
            .catch((err) => {
                this._logger.warn({error: err}, "DeleteAction.run() - Error");
                this._gameEditor.currentEntityDeleteInProgress = false;
                return this._modalUserFeedback.displayError({
                    error: {
                        title: "Delete",
                        errorTitle: "Delete IoT Platform",
                        errorMsg: err.message || "An error occurred while deleting the platform.",
                    },
                });
            });
    }
}

module.exports = DeleteAction;

DeleteAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.OdmOsPlatform",
];

DeleteAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    title: "Delete IoT Platform",
    shown: true,
    order: 9,
};
